// --> plugin that allows to perform action on route change
// @ts-nocheck
export default ({ app, route }: { app: any, route: any }) => {
  app.router.afterEach((to: any, from: any) => {
    /* if (process.browser && window?._mfq) {
      window._mfq.push(['newPageView', location.pathname]);
    } */
  });
};
